import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getParentOffsetWidth, on, off } from '@sparefoot/react-core/utils/dom';
import { Button } from 'components/core/Button';

import './SliderGallery.scss';

export default class SliderGallery extends PureComponent {
	constructor(props) {
		super(props);
		this.containerWidth = 0; // Width of the slider Container
		this.maxPull = 0;

		this.state = {
			itemWidth: 0, // Width of each thumbnail item
			sliderWidth: 0, // Width of the slider container
			offset: 0, // Transform offset
		};
	}

	componentDidMount() {
		this.reset();
		on('resize', this.reset);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.children !== this.props.children) {
			this.reset();
		} else if (prevProps.activeIndex !== this.props.activeIndex) {
			this.update();
		}
	}

	componentWillUnmount() {
		off('resize', this.reset);
	}

	getRef = (instance) => {
		this.instance = instance;
	};

	reset = () => {
		if (!this.instance) {
			return;
		}
		this.containerWidth = getParentOffsetWidth(this.instance);

		const itemWidth =
			(this.containerWidth - (this.props.numItems * 5 - 5)) /
			this.props.numItems;
		const sliderWidth = this.props.children.length * (itemWidth + 5);

		// the max offset for the slider
		this.maxPull = sliderWidth - this.containerWidth - 5;

		if (sliderWidth !== this.state.sliderWidth) {
			this.setState({ itemWidth, sliderWidth });
		}

		this.update();
	};

	update = () => {
		const { activeIndex } = this.props;
		const { itemWidth, sliderWidth } = this.state;

		// Get the active items offset
		const offsetFromLeft = itemWidth * activeIndex;

		// Check if the active item is past the mid point and the slided is overflown
		if (
			sliderWidth > this.containerWidth &&
			offsetFromLeft + itemWidth / 2 > this.containerWidth / 2
		) {
			// figure out what it would take to center the item
			const position =
				offsetFromLeft - (this.containerWidth - itemWidth) / 2;

			// find the closest stop that matches the offset
			const gutter =
				Math.ceil(position / (itemWidth + 5)) * (itemWidth + 5);

			// offset the slider
			const offset = Math.min(gutter, this.maxPull);
			this.setState({ offset });
		} else if (this.state.offset !== 0) {
			this.setState({ offset: 0 });
		}
	};

	goToItem = (index) => () => {
		this.props.onSelect(index);
	};

	render() {
		const { children, activeIndex } = this.props;
		const { sliderWidth, itemWidth, offset } = this.state;
		return (
			<ul
				className="ss-slider-gallery"
				ref={this.getRef}
				style={{
					width: `${sliderWidth}px`,
					transform: `translate3d(${offset * -1}px, 0px, 0px)`,
				}}
			>
				{children.map((child, index) => (
					<li
						key={child.key}
						className={classnames('gallery-item', {
							active: index === activeIndex,
						})}
						style={{
							width: `${itemWidth}px`,
							marginRight: '5px',
						}}
					>
						<Button
							className="gallery-button"
							onClick={this.goToItem(index)}
						>
							{child}
						</Button>
					</li>
				))}
			</ul>
		);
	}
}

SliderGallery.propTypes = {
	activeIndex: PropTypes.number,
	children: PropTypes.node.isRequired,
	numItems: PropTypes.number,
	onSelect: PropTypes.func.isRequired,
};

SliderGallery.defaultProps = {
	numItems: 9,
	activeIndex: 0,
};
